import React from 'react'
import useGlobalInfo from '../useGlobalInfo';
import useGlobalHeader from '../useGlobalHeader';
import useGlobalDisplay from '../useGlobalDisplay';
import useInfoStyle from '../useInfoStyle';

const InfoModal = ({ closeModal, modalHead }) => {

    const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
    const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
    const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
    const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
    const handleClose = () => {
        closeModal();
        document.getElementById('desktopClose').click();
    }
    return (
        <div class="col-xl-3 col-lg-4 text-center" id='dataModal'>
            <div className='info innerBody' name="InfoBox" style={{ borderRadius: "15px" }}>
                <div class="cross" onClick={handleClose} >
                </div>
                <h6 class="text-left">
                    {IsHeader}
                </h6>
                <p class="text-left">
                    {Isinfo}
                </p>
            </div>
        </div>
    )
}

export default InfoModal
